// Prikaz obavestenja (zvonce i stranica "Obavestenja" u profilu): ikona po vrsti i "pre 5 min"
const ICONS: Record<string, string> = {
  ad_message: 'icon-envelope',
  new_follower: 'icon-user-solid',
  ad_approved: 'icon-store-solid',
}

export function useNotificationDisplay() {
  const iconFor = (type: string) => ICONS[type] ?? 'icon-bell-solid'

  // "pre 5 min", "pre 3 h", "pre 2 d"
  const ago = (value: string) => {
    const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 60000))

    if (minutes < 1) return 'upravo sada'
    if (minutes < 60) return `pre ${minutes} min`
    if (minutes < 60 * 24) return `pre ${Math.round(minutes / 60)} h`

    return `pre ${Math.round(minutes / 60 / 24)} d`
  }

  return { iconFor, ago }
}
